import React from 'react';
import { useIncomeImport } from '../hooks/ImportIncome';
import AnimatedBackground from '../../utils/AnimatedBackground';
import TopBar from '../../utils/TopBar';
import Footer from '../../utils/Footer';

const ImportIncome: React.FC = () => {
  const {
    currentStep,
    formData,
    totalSteps,
    handleInputChange,
    handleOptionSelect,
    navigateToStep,
    handleSubmit,
    handleDateSelect,
    handleMonthChange,
    handleYearChange,
    isConfirmed
  } = useIncomeImport();

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <>
            <h2 className="text-xl font-semibold mb-6 text-white">Select Income Date</h2>
            <div className="flex flex-col items-center space-y-4">
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.dateType === 'current' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleDateSelect('current')}
              >
                Current Month
              </button>
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.dateType === 'previous' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                type="button"
                onClick={() => handleDateSelect('previous')}
              >
                Previous Month
              </button>
              
              {formData.dateType === 'previous' && (
                <div className="flex flex-col space-y-4 mt-4">
                  <select
                    value={formData.month}
                    onChange={(e) => handleMonthChange(e.target.value)}
                    className="w-64 p-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-blue-500 text-white"
                  >
                    <option value="">Select Month</option>
                    <option value="01">January</option>
                    <option value="02">February</option>
                    <option value="03">March</option>
                    <option value="04">April</option>
                    <option value="05">May</option>
                    <option value="06">June</option>
                    <option value="07">July</option>
                    <option value="08">August</option>
                    <option value="09">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                  
                  <select
                    value={formData.year}
                    onChange={(e) => handleYearChange(e.target.value)}
                    className="w-64 p-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-blue-500 text-white"
                  >
                    <option value="">Select Year</option>
                    {Array.from({ length: 5 }, (_, i) => (
                      <option key={i} value={new Date().getFullYear() - i}>
                        {new Date().getFullYear() - i}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <h2 className="text-xl font-semibold mb-6 text-white">Employment Regime</h2>
            <div className="flex justify-center space-x-4">
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.regime === 'clt' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleOptionSelect('regime', 'clt')}
              >
                CLT
              </button>
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.regime === 'pj' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleOptionSelect('regime', 'pj')}
              >
                PJ
              </button>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">Gross Salary</h2>
            <input
              type="number"
              name="grossSalary"
              value={formData.grossSalary}
              onChange={handleInputChange}
              className="w-64 p-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-blue-500 text-white"
              required
            />
          </>
        );
      case 4:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">VR (Vale Alimentação)</h2>
            <input
              type="number"
              name="vr"
              value={formData.vr}
              onChange={handleInputChange}
              className="w-64 p-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-blue-500 text-white"
              required
            />
          </>
        );
      case 5:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">Do you have any other source of income?</h2>
            <div className="flex justify-center space-x-4">
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.otherIncome === 'no' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleOptionSelect('otherIncome', 'no')}
              >
                No
              </button>
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.otherIncome === 'yes' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleOptionSelect('otherIncome', 'yes')}
              >
                Yes
              </button>
            </div>
          </>
        );
      case 6:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">Other Income Value</h2>
            <input
              type="number"
              name="otherIncomeValue"
              value={formData.otherIncomeValue}
              onChange={handleInputChange}
              className="w-64 p-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-blue-500 text-white"
              required
            />
          </>
        );
      case 7:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">Is this income taxed?</h2>
            <div className="flex justify-center space-x-4">
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.otherIncomeTaxed === 'no' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleOptionSelect('otherIncomeTaxed', 'no')}
              >
                No
              </button>
              <button
                className={`px-6 py-2 rounded-md transition-colors ${
                  formData.otherIncomeTaxed === 'yes' 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-100'
                }`}
                onClick={() => handleOptionSelect('otherIncomeTaxed', 'yes')}
              >
                Yes
              </button>
            </div>
          </>
        );
      case 8:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">Tax Rate (%) of the other income</h2>
            <input
              type="number"
              name="taxRate"
              value={formData.taxRate}
              onChange={handleInputChange}
              className="w-64 p-2 bg-gray-900 border border-gray-800 rounded-md focus:outline-none focus:border-blue-500 text-white"
              required
            />
          </>
        );
      case 9:
        return (
          <>
            <h2 className="text-xl font-semibold mb-4 text-white">Your selections:</h2>
            <div className="space-y-2 text-gray-300">
              <div><span className="font-semibold">Employment Regime:</span> {formData.regime.toUpperCase()}</div>
              <div><span className="font-semibold">Gross Salary:</span> {formData.grossSalary}</div>
              <div><span className="font-semibold">VR:</span> {formData.vr}</div>
              <div><span className="font-semibold">Other Income:</span> {formData.otherIncome}</div>
              <div><span className="font-semibold">Other Income Value:</span> {formData.otherIncomeValue}</div>
              <div><span className="font-semibold">Other Income Taxed:</span> {formData.otherIncomeTaxed}</div>
              <div><span className="font-semibold">Tax Rate over other income:</span> {formData.taxRate}</div>
            </div>
            <h2 className="text-xl font-semibold mt-4 mb-2 text-white">Are these selections correct?</h2>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col relative">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <TopBar 
          title="Income Management"
          subtitle="Manage and analyze your income with ease"
        />
        <main className="flex-grow flex items-center justify-center py-12 relative z-10">
          <div className="py-6 px-4 w-full">
            <div className="bg-black border border-gray-700 shadow sm:rounded-lg max-w-2xl mx-auto">
              <div className="px-8 py-6">
                <div className="mb-8">
                  <div className="flex justify-between items-center">
                    {Array.from({ length: totalSteps }, (_, i) => (
                      <div
                        key={i}
                        className={`w-8 h-8 rounded-full flex items-center justify-center ${
                          i + 1 === currentStep
                            ? 'bg-blue-600 text-white'
                            : i + 1 < currentStep
                            ? 'bg-green-600 text-white'
                            : 'bg-black border border-gray-800'
                        }`}
                      >
                        {i + 1}
                      </div>
                    ))}
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="text-white text-center">
                    {renderStepContent()}
                  </div>
                  <div className="mt-8 flex justify-end space-x-4">
                    {currentStep > 1 && (
                      <button
                        type="button"
                        onClick={() => navigateToStep(currentStep - 1)}
                        className="px-6 py-2 bg-black border border-gray-800 text-white rounded-md hover:bg-gray-900 transition-colors"
                      >
                        Previous
                      </button>
                    )}
                    {currentStep < totalSteps ? (
                      <button
                        type="button"
                        onClick={() => {
                          if (currentStep === 1 && !formData.dateType) {
                            alert('Please select a date type');
                            return;
                          }
                          if (currentStep === 1) {
                            if (formData.dateType === 'previous' && (!formData.month || !formData.year)) {
                              alert('Please select both month and year');
                              return;
                            }
                            navigateToStep(2);
                          } else {
                            navigateToStep(currentStep + 1);
                          }
                        }}
                        className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-500 transition-colors"
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-500 transition-colors"
                      >
                        {isConfirmed ? 'Confirm Import' : 'Review'}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default ImportIncome;

